/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Checkin_Call_Player_QrInputs */



/**
* | output |
* | --- |
* | "Scan the on-site QR code to check in." |
*
* @param {Tournament_Checkin_Call_Player_QrInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_checkin_call_player_qr = /** @type {((inputs?: Tournament_Checkin_Call_Player_QrInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Checkin_Call_Player_QrInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scannez le QR code sur place pour pointer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escanee el código QR en el lugar para hacer check-in.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Escaneie o QR code no local para fazer check-in.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansioni il QR code in loco per fare il check-in.")
	return /** @type {LocalizedString} */ ("Scan the on-site QR code to check in.")
});